module.exports = __webpack_public_path__ + "static/media/Unselected.f3a769e7.svg";